import emptyFieldValidate from "./empty.validate";

const usernameValidate = (username: string) => {
  let errMsg = undefined;

  errMsg = emptyFieldValidate(username, "Username");

  if (username && username.includes(" ")) {
    errMsg = "Spaces are not allowed.";
  }

  if (username) {
    if (username.length < 6 || username.length > 20) {
      errMsg = "Username should have 6 to 20 characters.";
    }
  }

  if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(username)) {
    errMsg = "Symbols are not allowed.";
  }

  return errMsg;
};

export default usernameValidate;
